
<template>
  <main v-if="progress" class="founder-journey mt-12">
    <div class="flex justify-between mb-10">
      <h1 class="font-Playfair text-[32px] leading-[42.66px]">Survey</h1>
    </div>
    <div class="flex flex-col flex-grow lg:pb-10 pb-8">
      <div class="max-w-[613px]">
        <div class="relative w-full mb-12">
          <label
            class="font-Rubik text-greyText text-[14px] leading-[16.59px] font-normal"
            htmlFor="recommendation"
          >
            <span class="text-red-400">*</span>
            How likely are you to recommend our company to a friend or colleague?
          </label>
          <input id="recommendation" type="range" min="0" max="100" v-model.number="data.recommendation" step="5" />
          <div id="rec-selector" class="h-[100px] w-[40px] absolute bottom-[-9px] left-[0%] z-[2] translate-x-[-50%]">
            <div id="rec-selectBtn" class="h-[30px] w-[30px] bg-black rounded-full absolute bottom-0 left-0"></div>
            <div id="rec-selectValue" class="currentValue w-[90px] h-[20px] absolute bottom-[-25px] left-[-30px] rounded-[4px] text-center leading-[20px]font-normal text-[16px] text-black">
                <span v-if="data.recommendation >= 0 && data.recommendation < 35" class="font-Rubik font-medium leading-[18.96px] text-[14px]">
                  {{data.score = 'Unlikely'}}
                </span>
                <span v-if="data.recommendation >= 35 && data.recommendation < 65" class="font-Rubik font-medium leading-[18.96px] text-[14px]">
                  {{data.score = 'Likely'}}
                </span>
                <span v-if="data.recommendation >= 65 && data.recommendation < 101" class="font-Rubik font-medium leading-[18.96px] text-[14px]">
                  {{data.score = 'Very Likely'}}
                </span>
            </div>
          </div>
          <div id="rec-progressBar" class="w-0 h-[4px] bg-black rounded-[3px] absolute"></div>
        </div>

        <div class="relative w-full mb-6">
          <label
            class="font-Rubik text-greyText text-[14px] leading-[16.59px] font-normal"
            for="score-reason"
          >
            <span class="text-red-400">*</span>
            What is the primary reason for your score?
          </label>
          <textarea
            id="score-reason"
            name="score-reason"
            type="text"
            rows="3"
            :class="[
            v$.score_reason.$error ? 'border-red-400' : 'border-grey-300'
            ]"
            class="px-4 py-4 mt-2 text-[15px] leading-[17.78px] font-Rubik placeholder-gray-400 text-black text-sm border border-borderGray rounded-[2px] w-full focus:outline-none focus:border-black hover:border-black focus:ring-0"
            placeholder="Lorem ipsum text"
            style="transition: 'all .15s ease'"
            v-model="v$.score_reason.$model"
            @blur="v$.score_reason.$touch()"
          />
          <span class="block w-max absolute right-0 font-Rubik font-light text-[12px] leading-[14.22px]">{{`${data.score_reason.length} of 400`}}</span>
          <div v-if="v$.score_reason.$error">
            <p
              v-if="v$.score_reason.required.$invalid"
              class="text-red-400 text-[10px] font-light"
            >Primary reason for your score is required</p>
          </div>
        </div>
        <div class="relative w-full mb-6">
          <label
            class="font-Rubik text-greyText text-[14px] leading-[16.59px] font-normal"
            for="suggestions"
          >
            <span class="text-red-400">*</span>
            What’s the one thing we could do to make it better?
          </label>
          <textarea
            id="suggestions"
            name="suggestions"
            type="text"
            rows="3"
            maxlength="400"
            :class="[
            v$.suggestions.$error ? 'border-red-400' : 'border-grey-300'
            ]"
            class="px-4 py-4 mt-2 text-[15px] leading-[17.78px] font-Rubik placeholder-gray-400 text-black text-sm border border-borderGray rounded-[2px] w-full focus:outline-none focus:border-black hover:border-black focus:ring-0"
            placeholder="Lorem ipsum text"
            style="transition: 'all .15s ease'"
            v-model="v$.suggestions.$model"
            @blur="v$.suggestions.$touch()"
          />
          <span class="block w-max absolute right-0 font-Rubik font-light text-[12px] leading-[14.22px]">{{`${data.suggestions.length} of 400`}}</span>
          <div v-if="v$.suggestions.$error">
            <p
              v-if="v$.suggestions.required.$invalid"
              class="text-red-400 text-[10px] font-light"
            >Suggestion is required</p>
          </div>
        </div>
        <div class="relative w-full mb-6">
          <label
            class="font-Rubik text-greyText text-[14px] leading-[16.59px] font-normal"
            for="improve-experience"
          >
            <span class="text-red-400">*</span>
            What could we do to improve your experience?
          </label>
          <textarea
            id="improve-experience"
            name="improve-experience"
            type="text"
            rows="3"
            maxlength="400"
            :class="[
            v$.improve_experience.$error ? 'border-red-400' : 'border-grey-300'
            ]"
            class="px-4 py-4 mt-2 text-[15px] leading-[17.78px] font-Rubik placeholder-gray-400 text-black text-sm border border-borderGray rounded-[2px] w-full focus:outline-none focus:border-black hover:border-black focus:ring-0"
            placeholder="Lorem ipsum text"
            style="transition: 'all .15s ease'"
            v-model="v$.improve_experience.$model"
            @blur="v$.improve_experience.$touch()"
          />
          <span class="block w-max absolute right-0 font-Rubik font-light text-[12px] leading-[14.22px]">{{`${data.improve_experience.length} of 400`}}</span>
          <div v-if="v$.improve_experience.$error">
            <p
              v-if="v$.improve_experience.required.$invalid"
              class="text-red-400 text-[10px] font-light"
            >Improving experience is required</p>
          </div>
        </div>
        <div class="relative w-full mb-6">
          <label
            class="font-Rubik text-greyText text-[14px] leading-[16.59px] font-normal"
            for="likes"
          >
            <span class="text-red-400">*</span>
            What do you like the most about Kinfolk?
          </label>
          <textarea
            id="likes"
            name="likes"
            type="text"
            rows="3"
            maxlength="400"
            :class="[
            v$.likes.$error ? 'border-red-400' : 'border-grey-300'
            ]"
            class="px-4 py-4 mt-2 text-[15px] leading-[17.78px] font-Rubik placeholder-gray-400 text-black text-sm border border-borderGray rounded-[2px] w-full focus:outline-none focus:border-black hover:border-black focus:ring-0"
            placeholder="Lorem ipsum text"
            style="transition: 'all .15s ease'"
            v-model="v$.likes.$model"
            @blur="v$.likes.$touch()"
          />
          <span class="block w-max absolute right-0 font-Rubik font-light text-[12px] leading-[14.22px]">{{`${data.likes.length} of 400`}}</span>
          <div v-if="v$.likes.$error">
            <p
              v-if="v$.likes.required.$invalid"
              class="text-red-400 text-[10px] font-light"
            >What do you like the most about Kinfolk is required</p>
          </div>
        </div>
        <div class="relative w-full mb-6">
          <label
            class="font-Rubik text-greyText text-[14px] leading-[16.59px] font-normal"
            for="dis-likes"
          >
            <span class="text-red-400">*</span>
            What do you like the least about Kinfolk?
          </label>
          <textarea
            id="dis-likes"
            name="dis-likes"
            type="text"
            rows="3"
            maxlength="400"
            :class="[
            v$.dislikes.$error ? 'border-red-400' : 'border-grey-300'
            ]"
            class="px-4 py-4 mt-2 text-[15px] leading-[17.78px] font-Rubik placeholder-gray-400 text-black text-sm border border-borderGray rounded-[2px] w-full focus:outline-none focus:border-black hover:border-black focus:ring-0"
            placeholder="Lorem ipsum text"
            style="transition: 'all .15s ease'"
            v-model="v$.dislikes.$model"
            @blur="v$.dislikes.$touch()"
          />
          <span class="block w-max absolute right-0 font-Rubik font-light text-[12px] leading-[14.22px]">{{`${data.dislikes.length} of 400`}}</span>
          <div v-if="v$.dislikes.$error">
            <p
              v-if="v$.dislikes.required.$invalid"
              class="text-red-400 text-[10px] font-light"
            >What do you like the least about Kinfolk is required</p>
          </div>
        </div>
        <div class="relative w-full mb-6">
          <label
            class="font-Rubik text-greyText text-[14px] leading-[16.59px] font-normal"
            for="missing-experience"
          >
            <span class="text-red-400">*</span>
            Was anything missing from your experience?
          </label>
          <textarea
            id="missing-experience"
            name="missing-experience"
            type="text"
            rows="3"
            maxlength="400"
            :class="[
            v$.missing_experience.$error ? 'border-red-400' : 'border-grey-300'
            ]"
            class="px-4 py-4 mt-2 text-[15px] leading-[17.78px] font-Rubik placeholder-gray-400 text-black text-sm border border-borderGray rounded-[2px] w-full focus:outline-none focus:border-black hover:border-black focus:ring-0"
            placeholder="Lorem ipsum text"
            style="transition: 'all .15s ease'"
            v-model="v$.missing_experience.$model"
            @blur="v$.missing_experience.$touch()"
          />
          <span class="block w-max absolute right-0 font-Rubik font-light text-[12px] leading-[14.22px]">{{`${data.missing_experience.length} of 400`}}</span>
          <div v-if="v$.missing_experience.$error">
            <p
              v-if="v$.missing_experience.required.$invalid"
              class="text-red-400 text-[10px] font-light"
            >Was anything missing from your experience is required</p>
          </div>
        </div>
        <div class="relative w-full mb-28">
          <label
            class="font-Rubik text-greyText text-[14px] leading-[16.59px] font-normal"
            for="wow-you"
          >
            <span class="text-red-400">*</span>
            What could we do to make you say ‘WOW’?
          </label>
          <textarea
            id="wow-you"
            name="wow-you"
            type="text"
            rows="3"
            maxlength="400"
            :class="[
            v$.wow_you.$error ? 'border-red-400' : 'border-grey-300'
            ]"
            class="px-4 py-4 mt-2 text-[15px] leading-[17.78px] font-Rubik placeholder-gray-400 text-black text-sm border border-borderGray rounded-[2px] w-full focus:outline-none focus:border-black hover:border-black focus:ring-0"
            placeholder="Lorem ipsum text"
            style="transition: 'all .15s ease'"
            v-model="v$.wow_you.$model"
            @blur="v$.wow_you.$touch()"
          />
          <span class="block w-max absolute right-0 font-Rubik font-light text-[12px] leading-[14.22px]">{{`${data.wow_you.length} of 400`}}</span>
          <div v-if="v$.wow_you.$error">
            <p
              v-if="v$.wow_you.required.$invalid"
              class="text-red-400 text-[10px] font-light"
            >Your suggestion is required</p>
          </div>
        </div>
        <div class="relative flex justify-end w-full mb-6">
          <button
            class="flex items-center justify-center bg-faintGrey text-black rounded-[6px] md:text-[16px] text-[14px] md:leading-[24px] leading-[20px] font-Rubik px-[28px] py-[14px] md:max-w-[157px] w-full outline-none focus:outline-none disabled:opacity-50 mr-8"
            @click="onSaveDraft"
          >
            Save draft
          </button>
          <button :disabled="v$.$invalid" @click="onSubmit" class="flex items-center justify-center bg-black text-white rounded-[6px] text-[16px] font-Rubik px-[28px] py-[14px] md:max-w-[118px] w-full outline-none focus:outline-none disabled:opacity-50">
            <span :class="submitLoading ? 'mr-2' : 'mr-0'" class="text-white">Submit</span>
            <svg v-if="submitLoading" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" style="background: none; display: block; shape-rendering: auto;" width="20px" height="20px" viewBox="0 0 100 100" preserveAspectRatio="xMidYMid">
              <circle cx="50" cy="50" fill="none" stroke="#ffffff" stroke-width="10" r="35" stroke-dasharray="164.93361431346415 56.97787143782138">
                <animateTransform attributeName="transform" type="rotate" repeatCount="indefinite" dur="1s" values="0 50 50;360 50 50" keyTimes="0;1"></animateTransform>
              </circle>
            </svg>
          </button>
        </div>
      </div>
    </div>
    <!-- <div v-show="progress.stage_nine === null">
      <div class="flex flex-col xl:flex-row justify-between pt-4 text-sm text-gray-500">
        <div class=" mb-4">
          <h3 class="font-Rubik text-[18px] leading-[21.33px] font-medium text-black">Post Call Data Request</h3>
          <p class="font-Rubik text-[16px] leading-[24px] font-light w-[303px] mt-3">Kindly provide all the required information to proceed to the next stage.</p>
          <p class="font-Rubik text-[16px] leading-[24px] font-normal w-[303px] mt-2">Estimated completion time: <span class="text-black">10mins</span></p>
          <p class="font-Rubik text-[14px] leading-[24px] font-normal text-red-400 mt-2">*Required</p>
        </div>
          <div class="flex flex-col flex-grow lg:pb-10 pb-8">
            <div class="max-w-[613px]">
              <div class="relative w-full mb-12">
                <label
                  class="font-Rubik text-greyText text-[14px] leading-[16.59px] font-normal"
                  htmlFor="recommendation"
                >
                  <span class="text-red-400">*</span>
                  How likely are you to recommend our company to a friend or colleague?
                </label>
                <input id="recommendation" type="range" min="0" max="100" v-model.number="data.recommendation" step="5" class="mt-10" />
                <div id="rec-selector" class="h-[100px] w-[40px] absolute bottom-[-9px] left-[0%] z-[2] translate-x-[-50%]">
                  <div id="rec-selectBtn" class="h-[30px] w-[30px] bg-black rounded-full absolute bottom-0 left-0"></div>
                  <div id="rec-selectValue" class="currentValue w-[90px] h-[20px] absolute bottom-[-25px] left-[-30px] rounded-[4px] text-center leading-[20px]font-normal text-[16px] text-black">
                      <span v-if="data.recommendation >= 0 && data.recommendation < 35" class="font-Rubik font-medium leading-[18.96px] text-[14px]">
                        {{data.score = 'Unlikely'}}
                      </span>
                      <span v-if="data.recommendation >= 35 && data.recommendation < 65" class="font-Rubik font-medium leading-[18.96px] text-[14px]">
                        {{data.score = 'Likely'}}
                      </span>
                      <span v-if="data.recommendation >= 65 && data.recommendation < 101" class="font-Rubik font-medium leading-[18.96px] text-[14px]">
                        {{data.score = 'Very Likely'}}
                      </span>
                  </div>
                </div>
                <div id="rec-progressBar" class="w-0 h-[4px] bg-black rounded-[3px] absolute top-[60px]"></div>
              </div>

              <div class="relative w-full mb-6">
                <label
                  class="font-Rubik text-greyText text-[14px] leading-[16.59px] font-normal"
                  for="score-reason"
                >
                  <span class="text-red-400">*</span>
                  What is the primary reason for your score?
                </label>
                <textarea
                  id="score-reason"
                  name="score-reason"
                  type="text"
                  rows="3"
                  :class="[
                  v$.score_reason.$error ? 'border-red-400' : 'border-grey-300'
                  ]"
                  class="px-4 py-4 mt-2 text-[15px] leading-[17.78px] font-Rubik placeholder-gray-400 text-black text-sm border border-borderGray rounded-[2px] w-full focus:outline-none focus:border-black hover:border-black focus:ring-0"
                  placeholder="Lorem ipsum text"
                  style="transition: 'all .15s ease'"
                  v-model="v$.score_reason.$model"
                  @blur="v$.score_reason.$touch()"
                />
                <span class="block w-max absolute right-0 font-Rubik font-light text-[12px] leading-[14.22px]">{{`${data.score_reason.length} of 400`}}</span>
                <div v-if="v$.score_reason.$error">
                  <p
                    v-if="v$.score_reason.required.$invalid"
                    class="text-red-400 text-[10px] font-light"
                  >Primary reason for your score is required</p>
                </div>
              </div>
              <div class="relative w-full mb-6">
                <label
                  class="font-Rubik text-greyText text-[14px] leading-[16.59px] font-normal"
                  for="suggestions"
                >
                  <span class="text-red-400">*</span>
                  What’s the one thing we could do to make it better?
                </label>
                <textarea
                  id="suggestions"
                  name="suggestions"
                  type="text"
                  rows="3"
                  maxlength="400"
                  :class="[
                  v$.suggestions.$error ? 'border-red-400' : 'border-grey-300'
                  ]"
                  class="px-4 py-4 mt-2 text-[15px] leading-[17.78px] font-Rubik placeholder-gray-400 text-black text-sm border border-borderGray rounded-[2px] w-full focus:outline-none focus:border-black hover:border-black focus:ring-0"
                  placeholder="Lorem ipsum text"
                  style="transition: 'all .15s ease'"
                  v-model="v$.suggestions.$model"
                  @blur="v$.suggestions.$touch()"
                />
                <span class="block w-max absolute right-0 font-Rubik font-light text-[12px] leading-[14.22px]">{{`${data.suggestions.length} of 400`}}</span>
                <div v-if="v$.suggestions.$error">
                  <p
                    v-if="v$.suggestions.required.$invalid"
                    class="text-red-400 text-[10px] font-light"
                  >Suggestion is required</p>
                </div>
              </div>
              <div class="relative w-full mb-6">
                <label
                  class="font-Rubik text-greyText text-[14px] leading-[16.59px] font-normal"
                  for="improve-experience"
                >
                  <span class="text-red-400">*</span>
                  What could we do to improve your experience?
                </label>
                <textarea
                  id="improve-experience"
                  name="improve-experience"
                  type="text"
                  rows="3"
                  maxlength="400"
                  :class="[
                  v$.improve_experience.$error ? 'border-red-400' : 'border-grey-300'
                  ]"
                  class="px-4 py-4 mt-2 text-[15px] leading-[17.78px] font-Rubik placeholder-gray-400 text-black text-sm border border-borderGray rounded-[2px] w-full focus:outline-none focus:border-black hover:border-black focus:ring-0"
                  placeholder="Lorem ipsum text"
                  style="transition: 'all .15s ease'"
                  v-model="v$.improve_experience.$model"
                  @blur="v$.improve_experience.$touch()"
                />
                <span class="block w-max absolute right-0 font-Rubik font-light text-[12px] leading-[14.22px]">{{`${data.improve_experience.length} of 400`}}</span>
                <div v-if="v$.improve_experience.$error">
                  <p
                    v-if="v$.improve_experience.required.$invalid"
                    class="text-red-400 text-[10px] font-light"
                  >Improving experience is required</p>
                </div>
              </div>
              <div class="relative w-full mb-6">
                <label
                  class="font-Rubik text-greyText text-[14px] leading-[16.59px] font-normal"
                  for="likes"
                >
                  <span class="text-red-400">*</span>
                  What do you like the most about Kinfolk?
                </label>
                <textarea
                  id="likes"
                  name="likes"
                  type="text"
                  rows="3"
                  maxlength="400"
                  :class="[
                  v$.likes.$error ? 'border-red-400' : 'border-grey-300'
                  ]"
                  class="px-4 py-4 mt-2 text-[15px] leading-[17.78px] font-Rubik placeholder-gray-400 text-black text-sm border border-borderGray rounded-[2px] w-full focus:outline-none focus:border-black hover:border-black focus:ring-0"
                  placeholder="Lorem ipsum text"
                  style="transition: 'all .15s ease'"
                  v-model="v$.likes.$model"
                  @blur="v$.likes.$touch()"
                />
                <span class="block w-max absolute right-0 font-Rubik font-light text-[12px] leading-[14.22px]">{{`${data.likes.length} of 400`}}</span>
                <div v-if="v$.likes.$error">
                  <p
                    v-if="v$.likes.required.$invalid"
                    class="text-red-400 text-[10px] font-light"
                  >What do you like the most about Kinfolk is required</p>
                </div>
              </div>
              <div class="relative w-full mb-6">
                <label
                  class="font-Rubik text-greyText text-[14px] leading-[16.59px] font-normal"
                  for="dis-likes"
                >
                  <span class="text-red-400">*</span>
                  What do you like the least about Kinfolk?
                </label>
                <textarea
                  id="dis-likes"
                  name="dis-likes"
                  type="text"
                  rows="3"
                  maxlength="400"
                  :class="[
                  v$.dislikes.$error ? 'border-red-400' : 'border-grey-300'
                  ]"
                  class="px-4 py-4 mt-2 text-[15px] leading-[17.78px] font-Rubik placeholder-gray-400 text-black text-sm border border-borderGray rounded-[2px] w-full focus:outline-none focus:border-black hover:border-black focus:ring-0"
                  placeholder="Lorem ipsum text"
                  style="transition: 'all .15s ease'"
                  v-model="v$.dislikes.$model"
                  @blur="v$.dislikes.$touch()"
                />
                <span class="block w-max absolute right-0 font-Rubik font-light text-[12px] leading-[14.22px]">{{`${data.dislikes.length} of 400`}}</span>
                <div v-if="v$.dislikes.$error">
                  <p
                    v-if="v$.dislikes.required.$invalid"
                    class="text-red-400 text-[10px] font-light"
                  >What do you like the least about Kinfolk is required</p>
                </div>
              </div>
              <div class="relative w-full mb-6">
                <label
                  class="font-Rubik text-greyText text-[14px] leading-[16.59px] font-normal"
                  for="missing-experience"
                >
                  <span class="text-red-400">*</span>
                  Was anything missing from your experience?
                </label>
                <textarea
                  id="missing-experience"
                  name="missing-experience"
                  type="text"
                  rows="3"
                  maxlength="400"
                  :class="[
                  v$.missing_experience.$error ? 'border-red-400' : 'border-grey-300'
                  ]"
                  class="px-4 py-4 mt-2 text-[15px] leading-[17.78px] font-Rubik placeholder-gray-400 text-black text-sm border border-borderGray rounded-[2px] w-full focus:outline-none focus:border-black hover:border-black focus:ring-0"
                  placeholder="Lorem ipsum text"
                  style="transition: 'all .15s ease'"
                  v-model="v$.missing_experience.$model"
                  @blur="v$.missing_experience.$touch()"
                />
                <span class="block w-max absolute right-0 font-Rubik font-light text-[12px] leading-[14.22px]">{{`${data.missing_experience.length} of 400`}}</span>
                <div v-if="v$.missing_experience.$error">
                  <p
                    v-if="v$.missing_experience.required.$invalid"
                    class="text-red-400 text-[10px] font-light"
                  >Was anything missing from your experience is required</p>
                </div>
              </div>
              <div class="relative w-full mb-28">
                <label
                  class="font-Rubik text-greyText text-[14px] leading-[16.59px] font-normal"
                  for="wow-you"
                >
                  <span class="text-red-400">*</span>
                  What could we do to make you say ‘WOW’?
                </label>
                <textarea
                  id="wow-you"
                  name="wow-you"
                  type="text"
                  rows="3"
                  maxlength="400"
                  :class="[
                  v$.wow_you.$error ? 'border-red-400' : 'border-grey-300'
                  ]"
                  class="px-4 py-4 mt-2 text-[15px] leading-[17.78px] font-Rubik placeholder-gray-400 text-black text-sm border border-borderGray rounded-[2px] w-full focus:outline-none focus:border-black hover:border-black focus:ring-0"
                  placeholder="Lorem ipsum text"
                  style="transition: 'all .15s ease'"
                  v-model="v$.wow_you.$model"
                  @blur="v$.wow_you.$touch()"
                />
                <span class="block w-max absolute right-0 font-Rubik font-light text-[12px] leading-[14.22px]">{{`${data.wow_you.length} of 400`}}</span>
                <div v-if="v$.wow_you.$error">
                  <p
                    v-if="v$.wow_you.required.$invalid"
                    class="text-red-400 text-[10px] font-light"
                  >Your suggestion is required</p>
                </div>
              </div>
              <div class="relative flex justify-end w-full mb-6">
                <button :disabled="v$.$invalid" @click="onSubmit" class="flex flex-nowrap bg-black text-white rounded-[2px] text-[16px] font-Rubik px-[28px] py-[14px] outline-none focus:outline-none disabled:opacity-50">
                  <span :class="submitLoading ? 'mr-2' : 'mr-0'" class="text-white">Submit</span>
                  <svg v-if="submitLoading" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" style="margin: auto; background: none; display: block; shape-rendering: auto;" width="20px" height="20px" viewBox="0 0 100 100" preserveAspectRatio="xMidYMid">
                    <circle cx="50" cy="50" fill="none" stroke="#ffffff" stroke-width="10" r="35" stroke-dasharray="164.93361431346415 56.97787143782138">
                      <animateTransform attributeName="transform" type="rotate" repeatCount="indefinite" dur="1s" values="0 50 50;360 50 50" keyTimes="0;1"></animateTransform>
                    </circle>
                  </svg>
                </button>
              </div>
            </div>
          </div>
      </div>
    </div>
    <div v-show="progress.stage_nine === 'Processing'">
      <div class=" my-10">
        <div class="flex flex-col justify-center items-center">
          <svg width="68" height="68" viewBox="0 0 68 68" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M18.0578 26.2933L14.5822 23.4978C12.92 26.5956 11.9378 30.1467 11.9378 34C11.9378 39.2133 13.7511 44.0489 16.8489 47.8267L7.63111 48.1289L9.21778 57.1956C3.55111 51.1511 0 42.9911 0 34C0 27.4267 1.88889 21.2311 5.13778 16.0178L1.58667 13.2222L17.4533 10.5022L18.0578 26.2933ZM49.8667 41.6311L53.3422 44.4267C55.0044 41.3289 55.9867 37.7778 55.9867 33.9244C55.9867 28.7111 54.1733 23.8756 51.0756 20.0978L60.3689 19.7956L58.7822 10.8044C64.4489 16.8489 68 25.0089 68 34C68 40.5733 66.1111 46.7689 62.8622 51.9822L66.4133 54.7778L50.5467 57.4978L49.8667 41.6311ZM41.6311 18.0578L44.4267 14.5822C41.3289 12.92 37.7778 11.9378 33.9244 11.9378C28.7111 11.9378 23.8756 13.7511 20.0978 16.8489L19.7956 7.63111L10.8044 9.21778C16.8489 3.55111 25.0089 0 34 0C40.5733 0 46.7689 1.88889 51.9822 5.13778L54.7778 1.58667L57.4978 17.4533L41.6311 18.0578ZM26.2933 49.8667L23.4978 53.4178C26.5956 55.08 30.1467 56.0622 34 56.0622C39.2133 56.0622 44.0489 54.2489 47.8267 51.1511L48.1289 60.3689L57.12 58.7822C51.0756 64.4489 42.9156 68 33.9244 68C27.3511 68 21.1556 66.1111 15.9422 62.8622L13.1467 66.4133L10.4267 50.5467L26.2933 49.8667Z" fill="#B5B540"/>
          </svg>
          <p class="w-[210px] mt-4 font-Rubik text-[13px] leading-[20px] text-greyText text-center">The documents provided within this stage are still being processed</p>
        </div>
      </div>
    </div>
    <div v-show="progress.stage_nine ===  'Approved'" class="flex flex-col justify-between pt-4 pb-2 text-sm text-gray-500">
      <div class=" my-10">
        <div class="flex flex-col justify-center items-center">
          <svg width="88" height="88" viewBox="0 0 88 88" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M86.05 49.1344L84.3955 46.8684C83.0287 44.9981 83.0107 42.4624 84.3415 40.5561L85.9601 38.2721C87.8304 35.6105 86.9672 31.9238 84.0897 30.3772L81.626 29.0464C79.5758 27.9494 78.4608 25.6654 78.8384 23.3815L79.306 20.6119C79.8456 17.4108 77.4537 14.4435 74.1986 14.3176L71.3931 14.1917C69.0732 14.1018 67.077 12.5192 66.4296 10.2892L65.6563 7.5916C64.7571 4.46241 61.3221 2.84386 58.3188 4.1387L55.7471 5.2537C53.6071 6.17088 51.1433 5.63136 49.5787 3.88692L47.7083 1.80079C45.5323 -0.627032 41.7377 -0.591065 39.5976 1.85474L37.7633 3.97684C36.2346 5.72128 33.7708 6.31475 31.6307 5.43354L29.0411 4.37249C26.0378 3.1316 22.6208 4.8041 21.7576 7.95128L21.0203 10.6489C20.4268 12.9148 18.4665 14.5154 16.1466 14.6413L13.3411 14.8031C10.0861 14.983 7.74815 17.9863 8.34162 21.1694L8.84517 23.921C9.25879 26.2049 8.17976 28.5069 6.14758 29.6219L3.70177 30.9886C0.860321 32.5712 0.0330622 36.2759 1.95734 38.9015L3.61186 41.1675C4.97863 43.0378 4.99661 45.5736 3.66581 47.4799L2.04726 49.7638C0.176933 52.4254 1.04016 56.1121 3.91758 57.6587L6.38137 58.9895C8.43154 60.0866 9.54654 62.3705 9.16888 64.6545L8.68331 67.406C8.14379 70.6071 10.5357 73.5745 13.7907 73.7004L16.5962 73.8263C18.9161 73.9162 20.9124 75.4988 21.5598 77.7288L22.3331 80.4263C23.2323 83.5555 26.6672 85.1741 29.6705 83.8792L32.2422 82.7642C34.3823 81.8471 36.8461 82.3866 38.4107 84.113L40.281 86.1992C42.457 88.627 46.2517 88.591 48.3917 86.1452L50.2261 84.0231C51.7547 82.2787 54.2185 81.6852 56.3586 82.5664L58.9483 83.6275C61.9516 84.8684 65.3685 83.1959 66.2317 80.0487L66.9691 77.3511C67.5805 75.1211 69.5588 73.5205 71.8787 73.3767L74.6842 73.2148C77.9393 73.035 80.2772 70.0317 79.6837 66.8485L79.1801 64.097C78.7665 61.813 79.8455 59.5111 81.8777 58.3961L84.3235 57.0293C87.147 55.4827 87.9563 51.76 86.05 49.1344ZM44.0037 72.4235C28.3217 72.4235 15.6071 59.7089 15.6071 44.027C15.6071 28.345 28.3217 15.6304 44.0037 15.6304C59.6856 15.6304 72.4002 28.345 72.4002 44.027C72.4002 59.7089 59.6856 72.4235 44.0037 72.4235Z" fill="#40B540"/>
            <path d="M40.3707 44.7821L37.8529 42.2464C36.3603 40.7357 33.9144 40.7357 32.4038 42.2284C30.8932 43.721 30.8932 46.1668 32.3858 47.6775L34.9036 50.2132L37.709 53.0187C39.1657 54.4934 41.5396 54.4934 43.0143 53.0367L45.8198 50.2492L55.603 40.5199C57.1137 39.0272 57.1137 36.5814 55.621 35.0708C54.1283 33.5601 51.6825 33.5601 50.1719 35.0528L40.3707 44.7821Z" fill="#40B540"/>
          </svg>
          <p class="w-[210px] mt-4 font-Rubik text-[13px] leading-[20px] text-greyText text-center">You have completed this stage of the diligence process</p>
        </div>
      </div>
    </div> -->
  </main>

</template>

<script>
import { useRoute, useRouter, onBeforeRouteLeave } from 'vue-router'
import { computed, onMounted, reactive, ref } from 'vue'
import useVuelidate from '@vuelidate/core'
import { required, url } from '@vuelidate/validators'
import { useStore } from 'vuex/'
import CompanyService from '@/services/company.service'
import Helpers from '../../utils/helpers'
import store from '@/store'
import DraftService from '../../services/draft.service'

const fetchCompany = async () => {
  try {
    const staleDisabled = {
      onboarding: false,
      stage_one: true,
      stage_two: true,
      stage_three: true,
      stage_four: true,
      stage_five: true,
      stage_six: true,
      stage_seven: true,
      stage_eight: true,
      feedback_survey: true
    }
    if (store.state.app.company) {
      const id = store.state.app.company.id
      const response = await CompanyService.fetchSingleCompany(id)
      if (response.status === 200 && response.data.status === 'success') {
        const disbaled = response.data.data.disabled
        return disbaled
      }
    } else return staleDisabled
  } catch (e) {
    return false
  }
}
export default {
  async beforeRouteEnter (to, from) {
    // console.log(to.name)
    const response = await fetchCompany()
    if (!response) {
      return false
    }
    const answer = Helpers.getStageByDisabledName(to.name, response)
    store.dispatch('setDisabledModal', { status: answer.status, message: 'You currently dont have permissions to view this stage. Keep checking your mailbox for an approval of your previous submission.' })
    if (answer.status) {
      return { name: 'Deligence' }
    }
  },
  setup () {
    const route = useRoute()
    const store = useStore()
    const router = useRouter()
    const fetchCompanyData = async () => {
      try {
        const id = store.state.app.company.id
        const response = await CompanyService.fetchSingleCompany(id)
        if (response.status === 200 && response.data.status === 'success') {
          const disbaled = response.data.data.disabled
          // store.dispatch('setDisabledModal', { status: disbaled.stage_three, message: 'You currently dont have permissions to view this stage. Keep checking your mailbox for an approval of your previous submission.' })
          return disbaled
        }
      } catch (e) {
        Helpers.processError(e, store, router)
      }
    }

    onBeforeRouteLeave(async (to, from) => {
      if (to.name === 'SignIn' || to.name === 'Home' || to.name === 'Impact Assessment' || to.name === 'SDG Alignment' || to.name === 'Financial' || to.name === 'Integrations' || to.name === 'User Details') {
        return true
      }
      const response = await fetchCompanyData()
      if (!response) {
        return false
      }
      const answer = Helpers.getStageByDisabledName(to.name, response)
      store.dispatch('setDisabledModal', { status: answer.status, message: 'You currently dont have permissions to view this stage. Keep checking your mailbox for an approval of your previous submission.' })
      if (answer.status) {
        return false
      }
    })
    const submitLoading = ref(false)

    const getDraft = async () => {
      const id = store.state.app.company.id
      try {
        const response = await DraftService.getDraft(id, 'STAGE 9')
        if (response.status === 200 && response.data.status === 'success' && response.data.data !== null) {
          const draft = response.data.data
          data.recommendation = draft.recommendation
          data.score = draft.score
          data.score_reason = draft.score_reason
          data.suggestions = draft.suggestions
          data.improve_experience = draft.improve_experience
          data.likes = draft.likes
          data.dislikes = draft.dislikes
          data.missing_experience = draft.missing_experience
          data.wow_you = draft.wow_you
        }
      } catch (e) {
        Helpers.processError(e, store, router)
      }
    }
    getDraft()

    const saveDraftLoading = ref(false)
    const onSaveDraft = async () => {
      saveDraftLoading.value = true
      const stagedata = {
        recommendation: data.recommendation,
        score: data.score,
        score_reason: data.score_reason,
        suggestions: data.suggestions,
        improve_experience: data.improve_experience,
        likes: data.likes,
        dislikes: data.dislikes,
        missing_experience: data.missing_experience,
        wow_you: data.wow_you
      }
      const draft = {
        company_id: company_id,
        stage: 'STAGE 9',
        data: stagedata
      }
      console.log(draft)
      try {
        const response = await DraftService.saveDraft(draft)
        if (response.status === 200 && response.data.status === 'success') {
          const success = {
            status: true,
            message: 'Draft has been successfully saved',
            color: 'green',
            type: 'success'
          }
          store.dispatch('setAlert', success)
          setTimeout(() => {
            store.dispatch('setAlert', {
              status: false,
              message: null,
              color: null,
              type: null
            })
          }, 2000)
        }
      } catch (e) {
        saveDraftLoading.value = false
        Helpers.processError(e, store, router)
      }
    }

    const data = reactive({
      recommendation: '',
      score: '',
      score_reason: '',
      suggestions: '',
      improve_experience: '',
      likes: '',
      dislikes: '',
      missing_experience: '',
      wow_you: ''
    })
    const rules = computed(() => ({
      score: { required },
      score_reason: { required },
      suggestions: { required },
      improve_experience: { required },
      likes: { required },
      dislikes: { required },
      missing_experience: { required },
      wow_you: { required }
    }))
    const effectSlider = () => {
      const recommendSlider = document.getElementById('recommendation')
      const recommendSelector = document.getElementById('rec-selector')
      const recommendProgressBar = document.getElementById('rec-progressBar')
      data.recommendation = 50
      const intialPosition = data.recommendation
      recommendSelector.style.left = `${intialPosition}%`
      recommendProgressBar.style.width = `${intialPosition}%`
      recommendSlider.oninput = () => {
        data.recommendation = recommendSlider.value
        const intialPosition = data.recommendation
        recommendSelector.style.left = `${intialPosition}%`
        recommendProgressBar.style.width = `${intialPosition}%`
      }
    }

    const user_id = store.state.auth.user.id
    const company_id = store.state.app.company.id
    const onSubmit = async () => {
      submitLoading.value = true
      const stagedata = {
        user_id: user_id,
        company_id: company_id,
        recommendation_score: Number(data.recommendation),
        score_reason: data.score_reason,
        improvements: data.suggestions,
        likes: data.likes,
        dislikes: data.dislikes,
        missing_experience: data.missing_experience,
        wow_you: data.wow_you
      }
      console.log(stagedata)
      if (stagedata) {
        const success = {
          status: true,
          message: 'Your data has been submitted successfully. We will review and reach out to you within the next 24 to 48 hours. '
        }
        store.commit('setSuccess', success)
      }
    }
    onMounted(() => {
      effectSlider()
    })

    const v$ = useVuelidate(rules, data)

    return {
      route,
      progress: computed(() => store.state.app.progress_status),
      data,
      v$,
      url,
      effectSlider,
      submitLoading,
      onSubmit,
      onSaveDraft
    }
  }
}
</script>

<style scoped>
input[type='range'] {
  width: 100%;
  height: 4px;
  -webkit-appearance: none;
  background-color: rgba(229, 230, 230, 1);
  border-radius: 5px;
  outline: none;
}

/* CHROME */
input[type='range']::-webkit-slider-runnable-track {
  -webkit-appearance: none;
  color: transparent;
}

input[type='range']::-webkit-slider-thumb {
  -webkit-appearance: none;
  width: 30px;
  height: 30px;
  cursor: pointer;
  z-index: 3;
  position: relative;
  box-shadow: 0 0 0 0 rgba(0, 0, 0, 0.1);
  transition: .3s ease-in-out;
  z-index: 3;
  outline: none;
}
/* input[type='range']::-moz-range-track-slider-thumb {
  -moz-appearance: none;
  appearance: none;
  outline: none;
} */

/* MOZ */
input[type='range']::-moz-range-thumb {
  width: 30px;
  height: 30px;
  appearance: none;
  -moz-appearance: none;
  outline: none;
  background: transparent;
  border: none;
}
input[type='range']:active::-webkit-slider-thumb {
  outline: none;
}
input[type="range"]::-moz-range-progress {
  height: 100%;
  border-radius: 5;
}
input[type="range"]::-moz-range-track {
  background-color: rgba(229, 230, 230, 1);
}
/* IE*/
input[type="range"]::-ms-fill-lower {
  background-color: #000000;
}
input[type="range"]::-ms-fill-upper {
  background-color: rgba(229, 230, 230, 1);
}
#rec-progressBar {
  top: 38px;
}
@media screen and (min-width: 768px) and (max-width: 830px) {
  #rec-progressBar {
    top: 62px;
  }
}
@media screen and (min-width: 305px) and (max-width: 531px) {
  #rec-progressBar {
    top: 62px;
  }
}
@media screen and (min-width: 227px) and (max-width: 305px) {
  #rec-progressBar {
    top: 87px;
  }
}
</style>
